import { Link } from "react-router-dom";
import { Phone, ArrowLeft, Sparkles } from "lucide-react";

export const Logo = ({ to = "/", light = false, compact = false }) => (
  <Link to={to} data-testid="logo-link" className="inline-flex items-center gap-2">
    <svg viewBox="0 0 48 28" className="h-6 w-10" aria-hidden="true">
      <rect x="0" y="2" width="30" height="24" rx="12" fill="var(--hf-green)" />
      <rect x="18" y="2" width="30" height="24" rx="12" fill="var(--hf-coral)" opacity="0.92" />
    </svg>
    <span className={`font-heading text-2xl ${compact ? "hidden" : ""} ${light ? "text-hf-cream" : "text-hf-ink"}`}>Handoff</span>
  </Link>
);

export const Emergency911 = ({ className = "" }) => (
  <a
    href="tel:911"
    data-testid="emergency-911-button"
    className={`hf-emergency fixed bottom-24 right-4 z-40 inline-flex min-h-[52px] items-center gap-2 rounded-full bg-hf-brick px-5 text-[15px] font-semibold text-white transition-transform active:scale-95 ${className}`}
  >
    <Phone className="h-5 w-5" /> Emergency? Call 911
  </a>
);

export const PageTitle = ({ eyebrow, title, sub, back }) => (
  <div className="mb-8 hf-rise">
    {back && (
      <Link to={back} data-testid="page-back-link" className="mb-4 inline-flex min-h-[44px] items-center gap-1 text-base font-medium text-hf-green">
        <ArrowLeft className="h-5 w-5" /> Back
      </Link>
    )}
    {eyebrow && <p className="hf-eyebrow mb-2">{eyebrow}</p>}
    <h1 className="font-heading text-3xl leading-tight text-hf-ink sm:text-4xl">{title}</h1>
    {sub && <p className="mt-3 text-base leading-relaxed text-hf-muted sm:text-lg">{sub}</p>}
  </div>
);

export const Chips = ({ options, value, onChange, multi = false, testid }) => {
  const on = (o) => (multi ? (value || []).includes(o) : value === o);
  const toggle = (o) => {
    if (!multi) return onChange(o);
    const cur = value || [];
    onChange(on(o) ? cur.filter((x) => x !== o) : [...cur, o]);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          type="button"
          key={o}
          data-on={on(o)}
          onClick={() => toggle(o)}
          className="hf-chip"
          data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          {o}
        </button>
      ))}
    </div>
  );
};

export const AiBadge = ({ children = "Written with AI. You approve it." }) => (
  <span className="inline-flex items-center gap-1 rounded-full bg-hf-sage px-3 py-1 text-sm font-medium text-hf-green">
    <Sparkles className="h-4 w-4" /> {children}
  </span>
);

export const OriginalWords = ({ label = "Your words", children, testid }) => (
  <div data-testid={testid} className="rounded-[10px] border-[1.5px] border-dashed border-hf-line bg-hf-creamdeep px-4 py-3">
    <p className="mb-1 text-[13px] font-semibold uppercase tracking-wider text-hf-muted">{label}</p>
    <p className="whitespace-pre-wrap text-base text-hf-ink/80">{children || "Nothing written."}</p>
  </div>
);

export const Loading = ({ label = "One moment..." }) => (
  <div data-testid="loading-state" className="flex min-h-[40vh] items-center justify-center text-lg text-hf-muted">
    <span className="mr-3 inline-block h-3 w-3 animate-ping rounded-full bg-hf-coral" />
    {label}
  </div>
);
